// @ts-nocheck
export const hasDuplicates = (arr) => arr.length !== new Set(arr).size;
